import { gql } from '@apollo/client';

export * from './appCreate.mutation.generated';

export const APP_CREATE = gql`
  mutation appCreate($appParams: AppCreateParams!) {
    appCreate(input: { appParams: $appParams }) {
      errors
      success
      app {
        id
        name
      }
    }
  }
`;
